

<div class="items-summary-wrapper">

	<div class="items-summary-close"><div class="_inner" (mousedown)="cancel()"><mat-icon>keyboard_arrow_down</mat-icon></div></div>


	<div class="items-summary-content">
		@if ($storage.alcoholQuestion) {
			<div class="alert alert-info">{{$storage.alcoholQuestion}}</div>
		}
		@for (offer of $storage.basket; track $index; let last = $last) {
		<div class="basket-row">
			<div class="_header d-flex align-items-center">
				<div class="_title">{{offer.name}}</div>
				<div class="_actions">
					@if (offer._enableEdit) {
						<button type="button" (mousedown)="editOffer(offer)" [disabled]="offer.isLoyaltyOffer">
							<mat-icon svgIcon="edit"></mat-icon>
						</button>
					}
					<button type="button" (mousedown)="deleteOffer(offer, false)" [class._inactive]="offer.quantity == 1">
						<mat-icon [svgIcon]="offer.quantity == 1 ? 'trash' : 'minus'"></mat-icon>
					</button>
					<div class="_counter text-highlight">
						{{offer.quantity}}
					</div>
					<button type="button" (mousedown)="duplicateOffer(offer)" [disabled]="offer.isLoyaltyOffer">
						<mat-icon svgIcon="plus"></mat-icon>
					</button>
				</div>
			</div>
			<div class="_summary">
				@if (offer._item && offer._item.summary) {
					<div class="_summary-row"><div>{{offer._item.summary.text}}</div></div>
				}
				@if (offer.selectionSummary?.length) {
					@for (group of offer.selectionSummary | filterBy:{_visible:true}; track $index;) {
					<div class="_summary-row">
						<b>{{group.name}}:</b>
						@for (item of group.items; track $index;) {
						<div>
							<div>
								@if (item.count > 1) {
									<span>{{ item.count }}*</span>
								}
								{{item.name || 'missing'}}
								@if (item._item.total > 0) {
									<span class="inline m-near-xs">+{{ item._item.total | lcurrency }}</span>
								}
							</div>
							@if (item.$wasEdit && item._item.summary) {
								<small class="block mb-1">{{ item._item.summary.text }}</small>
							}
						</div>
						}
					</div>
					}
				}
				@if (offer.offerRemrks) {
					<div class="_summary-row">
						<i>*{{ offer.offerRemrks }}</i>
					</div>
				}
			</div>
			<div class="_price text-highlight">
				{{offer.quantity * offer.total | lcurrency}}
			</div>
		</div>
		}
	</div>
	<div class="items-summary-bottom">
		<button mat-raised-button color="accent" class="lg main-continue-btn" type="button" (mousedown)="addItems()">
			<div class="_inner">
				<span>{{"TD.add-items-alt" | translate}}</span>
				<b>{{($storage.order.grandTotal) | lcurrency}}</b>
				<div class="_cont rotate-rtl"><mat-icon svgIcon="check-alt"></mat-icon></div>
			</div>
		</button>
	</div>
</div>

